module.exports = __webpack_public_path__ + "static/img/plus.8f990f2b.svg";